import React from 'react';
import { View, TouchableOpacity } from 'react-native';

import { TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { Icon, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { PRODUCT_STATUS } from '../../../../Services/Enums';
import { getThemeImages as getSohoThemeImages } from '../../../../Themes/Modes';
import SohoFrameworkTestKeys from '../../../../Utils/SohoFrameworkTestKeys';

import styles from './PlanInfo.Styles';

function PlanInfo({
  name,
  status,
  renewalDate,
  nameTextStyle,
  statusTextStyle,
  renewalDateTextStyle,
  onInformationIconPress,
  withInformationIcon,
  ...props
}) {
  const theme = useTheme();
  const sohoImages = getSohoThemeImages(theme.name);

  const renderInformationIcon = () => {
    return (
      <TouchableOpacity onPress={onInformationIconPress}>
        <View style={styles.iconStyle}>
          <Icon size={25} name={sohoImages.info_circle} type="image" />
        </View>
      </TouchableOpacity>
    );
  };
  return (
    <View style={styles.containerStyle(theme)}>
      <View style={styles.statusContainerStyle}>
        <VFText
          i18nKey={
            status === PRODUCT_STATUS.ACTIVE
              ? 'soho_plans_active_plan_card_label'
              : 'soho_plans_inactive_plan_card_label'
          }
          style={[
            styles.statusTextStyle,
            status === PRODUCT_STATUS.ACTIVE
              ? styles.activeStatusTextStyle
              : styles.inActiveStatusTextStyle,
            statusTextStyle,
          ]}
          testKey={SohoFrameworkTestKeys.PlanStatusTitle}
        />
        {renewalDate ? (
          <VFText
            i18nKey={renewalDate}
            style={[styles.renewalDateTextStyle(theme), renewalDateTextStyle]}
          />
        ) : null}
      </View>
      <View style={styles.iconAndTextContainerStyle}>
        <VFText
          testKey={SohoFrameworkTestKeys.PlanTitle}
          i18nKey={name}
          type="primary"
          style={[styles.nameTextStyle, nameTextStyle]}
        />
        {withInformationIcon && renderInformationIcon()}
      </View>
    </View>
  );
}

PlanInfo.propTypes = {
  name: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  renewalDate: PropTypes.string,
  nameTextStyle: TextPropTypes.style,
  statusTextStyle: TextPropTypes.style,
  renewalDateTextStyle: TextPropTypes.style,
  onInformationIconPress: PropTypes.func,
  withInformationIcon: PropTypes.bool,
};

export default PlanInfo;
